import { RedocStandalone } from 'redoc';

export default function (props) {
  const _props = {
    spec: props.spec,
    options: {
      hideDownloadButton: true,
      hideSingleRequestSampleTab: true,
      requiredPropsFirst: true,
      menuToggle: true,
      hideLogo: true,
    },
  };

  return (
      <RedocStandalone {..._props} />
  );
}
